// Shared by the two learner card screens (My courses, My certificates) so they stay visually
// identical - the numbers below are Figma-derived, and a change to one screen's grid that missed
// the other would show up as a mismatch between two sibling pages.

// Three 340px+ columns with a 16px gap, capped so the grid never stretches past three columns on
// a wide screen. `min(100%, 340px)` lets the track shrink below 340px on a narrow viewport (both
// learner screens are enabled on mobile) instead of forcing horizontal overflow.
export const LearnerContentMaxWidth = '1133px'

export const CardGridStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 340px), 1fr))',
  gap: 2,
  maxWidth: LearnerContentMaxWidth,
}
